
export const DEVICE_ID_COOKIE_NAME = "hz-device-id";